var map = {
	"./014-search.svg": "42cf",
	"./Dual Ball-1s-200px.gif": "e501",
	"./Sections/account.svg": "4411",
	"./Sections/account_dark.svg": "a271",
	"./Sections/activities_dark.svg": "b9d8",
	"./Sections/activity.svg": "0dd6",
	"./Sections/analysis.svg": "1c1c",
	"./Sections/billing.svg": "6279",
	"./Sections/billing_dark.svg": "1025",
	"./Sections/consignments.svg": "c4306",
	"./Sections/consignments_dark.svg": "c85d",
	"./Sections/contacts.svg": "21f5",
	"./Sections/contacts_dark.svg": "fc97",
	"./Sections/credit_dark.svg": "ab1a",
	"./Sections/credits.svg": "b77c",
	"./Sections/expense_dark.svg": "67e2",
	"./Sections/expenses.svg": "ab3b",
	"./Sections/metrices.svg": "8644",
	"./Sections/metrices_dark.svg": "dc18",
	"./Sections/orders.svg": "3b7e",
	"./Sections/orders_dark.svg": "c078",
	"./Sections/products.svg": "eb21",
	"./Sections/products_dark.svg": "48a6",
	"./Sections/recordDetails_dark.svg": "43bd",
	"./Sections/sale_dark.svg": "124d",
	"./Sections/sales.svg": "a623",
	"./Sections/security.svg": "133d",
	"./Sections/services.svg": "b11f",
	"./Sections/staff.svg": "e214",
	"./Sections/staff_dark.svg": "3abc",
	"./agency.svg": "1a44",
	"./arrow-down-sign-to-navigate.png": "c4af",
	"./back.png": "ae5c",
	"./bell.svg": "3845",
	"./branch.png": "c38f",
	"./branch1.png": "0a2a",
	"./branches.png": "0c42",
	"./building.svg": "4c9c",
	"./calendar.png": "10b5",
	"./check.svg": "51c7",
	"./close.svg": "2930",
	"./dashboard.svg": "0855",
	"./date-icon.png": "82cd",
	"./down-arrow.svg": "a9bb",
	"./edit.png": "8170",
	"./expand.svg": "b906",
	"./image-1.svg": "ef4a",
	"./image.svg": "da27",
	"./kpi.png": "61e9",
	"./kpi.svg": "dc0c",
	"./left-arrow.svg": "947f",
	"./loader-logo.jpg": "32e4",
	"./login-bg.jpg": "9ba7",
	"./login-bg.svg": "faa4",
	"./login.png": "24a9",
	"./logo-text.jpeg": "40ed",
	"./logo-upload.png": "ef7d",
	"./logo.png": "9d64",
	"./logout.svg": "4488",
	"./menu.png": "11ab",
	"./more.svg": "9fa2",
	"./not_found.svg": "5773",
	"./notpending.png": "433d",
	"./okay.svg": "6f86",
	"./options.svg": "bd6c",
	"./pen.svg": "800f",
	"./pending.png": "1a0d",
	"./pie-graph.svg": "a80b",
	"./placeholder.svg": "59a1",
	"./product-placeholder.jpg": "9e1c",
	"./product.jpg": "32d1",
	"./product.png": "52bb",
	"./productP.png": "b888",
	"./product_summary.png": "65a0",
	"./profile.png": "b31e",
	"./search.png": "1b61",
	"./settings.svg": "09a5",
	"./tick.png": "4b11",
	"./transaction.png": "989f",
	"./transactions.png": "96fc",
	"./transactions.svg": "e2ac",
	"./up-arrow.svg": "5743",
	"./update-list.png": "4bd9",
	"./upload.svg": "ad34",
	"./user roles.png": "d6ce",
	"./user-roles.svg": "4108"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";